import { AsyncPipe, NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AddressSuggestionsSelectModule } from '@sdvor/delivery/ui';
import { FormFieldComponent, TodayTomorrowDatePipeModule } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { ShopsMapModule } from '../shops-map/shops-map.module';
import { ShopListDesktopComponent } from './desktop/shop-list-desktop.component';
import { ShopListMobileComponent } from './mobile/shop-list-mobile.component';

@NgModule({
  imports: [
    NgIf,
    NgFor,
    NgClass,
    NgTemplateOutlet,
    AsyncPipe,
    ReactiveFormsModule,
    AddressSuggestionsSelectModule,
    IconModule,
    NgbTooltipModule,
    FormFieldComponent,
    ShopsMapModule,
    TodayTomorrowDatePipeModule,
  ],
  declarations: [ShopListDesktopComponent, ShopListMobileComponent],
  exports: [ShopListDesktopComponent, ShopListMobileComponent],
})
export class ShopListModule {}
